<template>
  <div class="wrapper">
    <app-header></app-header>
    <menu-sidebar></menu-sidebar>
    <div class="content-wrapper">
      <router-view></router-view>
    </div>
    <app-footer></app-footer>
    <div
        id="sidebar-overlay"
        role="presentation"
        @click="onToggleMenuSidebar"
    />
  </div>
</template>

<script>
import Header from './header/header.vue';
import MenuSidebar from './menu-sidebar/menu-sidebar.vue';
import Footer from './footer/footer.vue';

export default {
  components: {
    'app-header': Header,
    'menu-sidebar': MenuSidebar,
    'app-footer': Footer
  },
  watch: {
    watchLayoutChanges: () => {
    }
  },
  data() {
    return {
        appElement: null,
    }
  },
  computed: {
    watchLayoutChanges() {
      if (!this.appElement) {
        return;
      }
      this.appElement.classList.remove('dark-mode');
      this.appElement.classList.remove('sidebar-closed');
      this.appElement.classList.remove('sidebar-collapse');
      this.appElement.classList.remove('sidebar-open');
      this.appElement.classList.remove('control-sidebar-slide-open');

      if (this.darkModeSelected) {
        this.appElement.classList.add('dark-mode');
      }

      if (!this.controlSidebarCollapsed) {
        this.appElement.classList.add('control-sidebar-slide-open');
      }

      if (this.menuSidebarCollapsed && this.screenSize === 'lg') {
        this.appElement.classList.add('sidebar-collapse');
      } else if (this.menuSidebarCollapsed && this.screenSize === 'xs') {
        this.appElement.classList.add('sidebar-open');
      } else if (!this.menuSidebarCollapsed && this.screenSize !== 'lg') {
        this.appElement.classList.add('sidebar-closed');
        this.appElement.classList.add('sidebar-collapse');
      }
      return this.appElement.classList.value;
    },
    darkModeSelected() {
      return this.$store.getters['ui/darkModeSelected'];
    },
    menuSidebarCollapsed() {
      return this.$store.getters['ui/menuSidebarCollapsed'];
    },
    controlSidebarCollapsed() {
      return this.$store.getters['ui/controlSidebarCollapsed'];
    },
    screenSize() {
      return this.$store.getters['ui/screenSize'];
    },
  },
  methods: {
    onToggleMenuSidebar() {
      this.$store.dispatch('ui/toggleMenuSidebar');
    },
  },
  mounted() {
    this.appElement = document.getElementById('application');
    this.appElement.classList.add('sidebar-mini');
    this.appElement.classList.add('layout-fixed');
  },
  unmounted() {
    this.appElement.classList.remove('sidebar-mini');
    this.appElement.classList.remove('layout-fixed');
  }
}
</script>

<style>

#application .ve-loading.ve-loading-overlay {
  z-index: 49;
}

.empty-data {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 48px;
  width: 100%;
  color: #666;
  font-size: 16px;
  border: 1px solid #eee;
  border-top: 0;
}

.mb-10 {
  margin-bottom: 10px;
}

.mt-10 {
  margin-top: 10px;
}


</style>
